// extracted by css-extract-rspack-plugin
export default {"loading":"Y7xmG"};